module.exports = __webpack_public_path__ + "img/feature_breaks.8b05ea38.svg";